/* eslint-disable no-nested-ternary */
import {
    Button,
    Input, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'appkit-react';

import '../styles/addDomainModal.scss';

const AddDomainModal = ({
    domainUrl, domainError, onSave, visible, setVisible, addDomainLoading, onBlurHandler, isDomainValid, inputHandler,
}) => {
    const getDomainErrorMsg = () => {
        if (domainError) {
            return 'Domain is required';
        }
        return isDomainValid ? 'Invalid domain' : '';
    };

    return (
        <div>
            <Modal
                className="add-and-edit-modal"
                visible={visible}
                onCancel={() => { setVisible(false); }}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">Add Domain</div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="domain-modal-container">
                        <div className="edit-form-input-right-col">
                            <Input
                                type="text"
                                name="domainUrl"
                                value={domainUrl}
                                prefix={(
                                    <span className="http-prefix">https://</span>
                                )}
                                hasError={domainError || isDomainValid}
                                errMsg={getDomainErrorMsg()}
                                onChange={e => inputHandler(e)}
                                onBlur={onBlurHandler}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter style={{ justifyContent: 'flex-end' }}>
                    <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> CANCEL </Button>
                    <Button kind="primary" size="lg" onClick={onSave} isLoading={addDomainLoading}> SAVE </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddDomainModal;
